import { useTranslation } from 'react-i18next';

/**
 * "I agree to the terms and conditions": text, then a link to the terms. Tenants can override all three keys; an empty
 * link text (a space counts as empty) leaves out the link, and an empty URL keeps the link text as plain text.
 */
export const TermsAndCondition = () => {
    const { t } = useTranslation();
    const linkText = t('Account.Label.TermsAndConditions2').trim();
    const url = t('Account.Link.TermsAndConditions').trim();

    return (
        <span>
            {t('Account.Label.TermsAndConditions1')}
            {linkText &&
                (url ? (
                    <b>
                        <a href={url} target="_blank" rel="noopener noreferrer">
                            {linkText}
                            <span className="sr-only"> {t('Generic.Link.OpensInNewTab')}</span>
                        </a>
                    </b>
                ) : (
                    linkText
                ))}
        </span>
    );
};
